import React, {ReactNode, useState} from "react"
import {RouteContext} from "../utils/context";
import urlToList from "../utils/urlToList";
import {pathToRegexp} from "path-to-regexp";
import {Link, useHistory} from "react-router-dom";
import {PageHeader} from "@ant-design/pro-components";
import styles from "./pageHeaderLayout.module.css";
import {useSelector} from "react-redux";
import {RootState} from "../models";
import {Button, Card, Space} from "antd";


interface PageHeaderLayoutProps {
    children: ReactNode,
    canBack?: boolean,
    withFooterBar?: boolean,
    onOk?: () => void,
    onCancel?: () => void
    okBtnText?:string
    cancelBtnText?:string
    btnLoading?: boolean
}

function PageHeaderLayout(props: PageHeaderLayoutProps) {
    const routes = useSelector((state: RootState) => state.auth.routes)

    const {children, canBack = false} = props
    const history = useHistory()

    function generateBreadcrumb(routes?: Routes, path?: string) {
        if (!routes || !path) return []
        const paths = urlToList(path)
        return paths.map(it => {
            const regexp = pathToRegexp(it)
            return Object.keys(routes).find(route => regexp.test(route))
        }).filter(it => it).map(it => {
            const route = routes[it!]
            return {
                path: (route.component || route.render) ? it! : "",
                href: (route.component || route.render) ? it! : "",
                breadcrumbName: route.name || "",
                title: route.name || ""
            }
        })
    }

    return (
        <div className={props.withFooterBar ? styles.pageContainerWithFooter : styles.pageContainer}>
            <RouteContext.Consumer>
                {props => {
                    const route = props?.routes[props?.path]
                    const breadcrumb = generateBreadcrumb(props?.routes, props?.path)
                    breadcrumb.unshift({path: '/', href: '/', breadcrumbName: "首页", title: "首页"})
                    return (
                        <PageHeader ghost={false}
                                    className={styles.pageHeader}
                                    breadcrumb={{
                                        routes: breadcrumb,
                                        itemRender: (route: any) => {
                                            return !route.href ? <span>{route.title}</span> :
                                                <Link to={route.href}><span
                                                    className={styles.breadcrumbLink}>{route.title}</span></Link>
                                        }
                                    }}
                                    onBack={canBack ? () => {
                                        history.goBack()
                                    } : undefined}
                        />
                    )
                }}
            </RouteContext.Consumer>
            <div style={props.withFooterBar ? {height: '100%', overflow: 'scroll'} : {}}>
                {children}
            </div>
            {props.withFooterBar && (
                <Card className={styles.footer}>
                    <Space>
                        <Button loading={props.btnLoading} type={"primary"} onClick={props.onOk}>{props.okBtnText ?? '保存'}</Button>
                        <Button onClick={props.onCancel}>{props.cancelBtnText ?? '取消'}</Button>
                    </Space>
                </Card>
            )}
        </div>
    )

}

export default PageHeaderLayout
